import { Row, Col } from 'antd';
import moment from 'moment';
import { Component } from 'react'
import helper from '../../utils/helper';
//seNowPay
import NowPayLogo from '../../assets/images/seNowpayLogo.png';
import Signature from '../../assets/images/exstraSign.png';
import { IInvoiceData } from '../../utils/commonInterfaces';

interface Props {
    data: IInvoiceData;
}

export class InvoiceTemp extends Component<Props> {
    render() {
        const { data } = this.props;
        const claimHeaderStyle = {
            marginTop: 8,
            marginBottom: 8,
            padding: '10px 12px',
            background: 'linear-gradient(90deg, #f7f9fc 0%, #eef2f7 50%, #f7f9fc 100%)',
            border: '1px solid #dee2e6',
            borderRadius: 8,
        };

        const claimTitleStyle = {
            fontSize: 17,
            fontWeight: 700,
            color: '#3d4a5a',
            letterSpacing: '0.03em',
            marginBottom: 4,
            textAlign: 'center' as const,
        };

        

        const claimMetaStyle = {
            display: 'flex',
            justifyContent: 'center',
            gap: 10,
            flexWrap: 'wrap' as const,
        };

        const claimPillStyle = {
            padding: '3px 10px',
            borderRadius: 6,
            border: '1px solid #d8e1ec',
            backgroundColor: '#ffffff',
            fontSize: '11px',
            color: '#4f5d6b',
            lineHeight: 1.4,
            fontWeight: 600,
        };

        const companySectionStyle = {
            marginTop: 8,
            marginBottom: 8,
            padding: '10px',
            backgroundColor: '#f8f9fb',
            border: '1px solid #dee2e6',
            borderRadius: 8,
        };

        const companySectionTitleStyle = {
            textAlign: 'center' as const,
            color: '#3f4d5c',
            fontWeight: 700,
            margin: '0 0 8px 0',
            fontSize: '13px',
            textTransform: 'uppercase' as const,
            letterSpacing: '0.06em',
        };

        const companyCardStyle = {
            padding: '9px',
            backgroundColor: '#ffffff',
            border: '1px solid #e3e9f2',
            borderRadius: 8,
            minHeight: '100%',
            boxShadow: '0 1px 3px rgba(26, 39, 57, 0.05)',
        };

        const companyCardHeaderStyle = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 6,
            paddingBottom: 4,
            borderBottom: '1px solid #edf1f5',
        };

        const companyCardTitleStyle = {
            fontSize: '12px',
            fontWeight: 700,
            color: '#4b5661',
        };

        

        const companyItemStyle = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 8,
            marginBottom: 6,
            fontSize: '11px',
            lineHeight: 1.35,
        };

        const companyItemLabelStyle = {
            color: '#687789',
            fontWeight: 600,
            whiteSpace: 'nowrap' as const,
        };

        const companyItemValueStyle = {
            color: '#1f2b3a',
            fontWeight: 600,
            textAlign: 'right' as const,
            wordBreak: 'break-word' as const,
        };

        return (
            <>
                <div className="invoice">
                    <div className="nowPayLogo">
                        <img src={NowPayLogo} alt="" width={'100px'} />
                    </div>
                    <div className="invoiceHeader">
                        <Row>
                            <Col span={24}>
                                <div className="invoice-taxable-claim-title" style={claimHeaderStyle}>
                                    <div style={claimTitleStyle}>Taxable Claim</div>
                                    <div style={claimMetaStyle}>
                                        <span style={claimPillStyle}>Invoice No. {data?.installmentTotal?.serialNumber || 'N/A'}</span>
                                        <span style={claimPillStyle}>Date: {data?.date ? moment(data.date).format("MMM DD, YYYY") : 'N/A'}</span>
                                        <span style={claimPillStyle}>Issuance Date: {moment().format("MMM DD, YYYY HH:mm")}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div style={companySectionStyle}>
                        <h4 style={companySectionTitleStyle}>Company Info</h4>
                        <Row gutter={8}>
                            <Col span={12}>
                                <div style={companyCardStyle}>
                                    <div style={companyCardHeaderStyle}>
                                        <span style={companyCardTitleStyle}>From</span>
                                    </div>
                                    <div style={companyItemStyle}>
                                        <span style={companyItemLabelStyle}>Company:</span>
                                        <span style={companyItemValueStyle}>Now Access</span>
                                    </div>
                                    <div style={companyItemStyle}>
                                        <span style={companyItemLabelStyle}>Address:</span>
                                        <span style={companyItemValueStyle}>AlKhobar, Rawabi Dis, King Faisal, 34421</span>
                                    </div>
                                    <div style={companyItemStyle}>
                                        <span style={companyItemLabelStyle}>Tax ID:</span>
                                        <span style={companyItemValueStyle}>{data?.installmentTotal?.sellerTaxIdentificationNumber || data?.sellerTaxIdentificationNumber || 'N/A'}</span>
                                    </div>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div style={companyCardStyle}>
                                    <div style={companyCardHeaderStyle}>
                                        <span style={companyCardTitleStyle}>To</span>
                                    </div>
                                    <div style={companyItemStyle}>
                                        <span style={companyItemLabelStyle}>Company:</span>
                                        <span style={companyItemValueStyle}>{data?.installmentTotal?.companyName || data?.com || 'N/A'}</span>
                                    </div>
                                    <div style={companyItemStyle}>
                                        <span style={companyItemLabelStyle}>Address:</span>
                                        <span style={companyItemValueStyle}>{data?.installmentTotal?.nationalAddress || data?.nationalAddress || 'N/A'}</span>
                                    </div>
                                    <div style={companyItemStyle}>
                                        <span style={companyItemLabelStyle}>Tax ID:</span>
                                        <span style={companyItemValueStyle}>{data?.installmentTotal?.taxIdentificationNumber || data?.taxIdentificationNumber || 'N/A'}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    

                    <div className="user-status-section" style={{
                        background: 'linear-gradient(90deg, #4ecdc4, #44a08d)',
                        padding: '4px 12px',
                        margin: '4px 0',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}>
                        <span style={{
                            fontSize: '12px',
                            color: '#ffffff',
                            fontWeight: 600,
                            letterSpacing: '0.3px'
                        }}>
                            👤 Users: All Company Users
                        </span>
                    </div>

                    <div className="invoiceBody">
                        <table className='invoiceTable' style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            fontSize: '12px'
                        }}>
                            <tr>
                                <th style={{ backgroundColor: '#f8f9fa', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '12px', fontWeight: 700 }}>Description</th>
                                <th style={{ backgroundColor: '#f8f9fa', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '12px', fontWeight: 700 }}>Amount</th>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: '#fff', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '12px' }}>Total Due Collection For Active Users</td>
                                <td style={{ backgroundColor: '#fff', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '12px', fontWeight: 600 }}><span>{data?.installmentTotal?.totalDueActiveUsers ? helper.amountFormatter(data?.installmentTotal?.totalDueActiveUsers) : '00,00'} SAR</span></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: '#fff', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '12px' }}>Total Due Collection For Resigned Users</td>
                                <td style={{ backgroundColor: '#fff', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '12px', fontWeight: 600 }}><span>{data?.installmentTotal?.totalDueResignedUsers ? helper.amountFormatter(data?.installmentTotal?.totalDueResignedUsers) : '00,00'} SAR</span></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: '#fff', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '12px', fontWeight: 700 }}>Total Due Collection</td>
                                <td style={{ backgroundColor: '#fff', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '12px', fontWeight: 700 }}><span>{data?.installmentTotal?.totalDueThisMonth ? helper.amountFormatter(data?.installmentTotal?.totalDueThisMonth) : '00,00'} SAR</span></td>
                            </tr>
                        </table>
                    </div>
                    {/* Details Section */}
                    <div>
                        <div style={{
                            background: '#f8f9fa',
                            padding: '6px 10px',
                            margin: '6px 0',
                            borderRadius: '4px',
                            border: '1px solid #dee2e6'
                        }}>
                            <h4 style={{
                                textAlign: 'center',
                                color: '#7285a4',
                                fontWeight: 700,
                                margin: '0 0 8px 0',
                                fontSize: '13px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                paddingBottom: '6px'
                            }}>
                                Details
                            </h4>

                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                backgroundColor: '#fff',
                                fontSize: '12px'
                            }}>
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: '#f8f9fa', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '13px', textAlign: 'left', fontWeight: 700 }}>Description</th>
                                        <th style={{ backgroundColor: '#f8f9fa', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '13px', textAlign: 'center', fontWeight: 700 }}>Active Users</th>
                                        <th style={{ backgroundColor: '#f8f9fa', padding: '4px 6px', border: '1px solid #dee2e6', fontSize: '13px', textAlign: 'center', fontWeight: 700 }}>Resigned Users</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', fontWeight: 500, color: '#212529', fontSize: '12px' }}>Salary Advances Principal</td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.activeUsersSummary?.salaryAdvancesPrincipal !== undefined && data?.installmentTotal?.activeUsersSummary?.salaryAdvancesPrincipal !== null
                                                ? helper.amountFormatter(data.installmentTotal.activeUsersSummary.salaryAdvancesPrincipal) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.resignedUsersSummary?.salaryAdvancesPrincipal !== undefined && data?.installmentTotal?.resignedUsersSummary?.salaryAdvancesPrincipal !== null
                                                ? helper.amountFormatter(data.installmentTotal.resignedUsersSummary.salaryAdvancesPrincipal) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', fontWeight: 500, color: '#212529', fontSize: '12px' }}>Salary Advances Fees</td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.activeUsersSummary?.salaryAdvancesFees !== undefined && data?.installmentTotal?.activeUsersSummary?.salaryAdvancesFees !== null
                                                ? helper.amountFormatter(data.installmentTotal.activeUsersSummary.salaryAdvancesFees) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.resignedUsersSummary?.salaryAdvancesFees !== undefined && data?.installmentTotal?.resignedUsersSummary?.salaryAdvancesFees !== null
                                                ? helper.amountFormatter(data.installmentTotal.resignedUsersSummary.salaryAdvancesFees) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', fontWeight: 500, color: '#212529', fontSize: '12px' }}>Salary Advances VAT</td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.activeUsersSummary?.salaryAdvancesVAT !== undefined && data?.installmentTotal?.activeUsersSummary?.salaryAdvancesVAT !== null
                                                ? helper.amountFormatter(data.installmentTotal.activeUsersSummary.salaryAdvancesVAT) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.resignedUsersSummary?.salaryAdvancesVAT !== undefined && data?.installmentTotal?.resignedUsersSummary?.salaryAdvancesVAT !== null
                                                ? helper.amountFormatter(data.installmentTotal.resignedUsersSummary.salaryAdvancesVAT) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', fontWeight: 500, color: '#212529', fontSize: '12px' }}>Previous Dues</td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.activeUsersSummary?.previousDues !== undefined && data?.installmentTotal?.activeUsersSummary?.previousDues !== null
                                                ? helper.amountFormatter(data.installmentTotal.activeUsersSummary.previousDues) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.resignedUsersSummary?.previousDues !== undefined && data?.installmentTotal?.resignedUsersSummary?.previousDues !== null
                                                ? helper.amountFormatter(data.installmentTotal.resignedUsersSummary.previousDues) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', fontWeight: 500, color: '#212529', fontSize: '12px' }}>Early Settlement Amounts</td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.activeUsersSummary?.earlySettlementAmounts !== undefined && data?.installmentTotal?.activeUsersSummary?.earlySettlementAmounts !== null
                                                ? helper.amountFormatter(data.installmentTotal.activeUsersSummary.earlySettlementAmounts) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.resignedUsersSummary?.earlySettlementAmounts !== undefined && data?.installmentTotal?.resignedUsersSummary?.earlySettlementAmounts !== null
                                                ? helper.amountFormatter(data.installmentTotal.resignedUsersSummary.earlySettlementAmounts) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', fontWeight: 500, color: '#212529', fontSize: '12px' }}>Total Rewards Applied</td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.activeUsersSummary?.totalRewardsApplied !== undefined && data?.installmentTotal?.activeUsersSummary?.totalRewardsApplied !== null
                                                ? helper.amountFormatter(data.installmentTotal.activeUsersSummary.totalRewardsApplied) + ' SAR'
                                                : 'N/A'}
                                        </td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.resignedUsersSummary?.totalRewardsApplied !== undefined && data?.installmentTotal?.resignedUsersSummary?.totalRewardsApplied !== null
                                                ? helper.amountFormatter(data.installmentTotal.resignedUsersSummary.totalRewardsApplied) + ' SAR'
                                                : 'N/A'}
                                        </td>
                                    </tr>
                                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', fontWeight: 700, color: '#212529', fontSize: '12px' }}>Total Due Collection</td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', fontWeight: 700, color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.activeUsersSummary?.totalDueCollection !== undefined && data?.installmentTotal?.activeUsersSummary?.totalDueCollection !== null
                                                ? helper.amountFormatter(data.installmentTotal.activeUsersSummary.totalDueCollection) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                        <td style={{ padding: '3px 4px', border: '1px solid #dee2e6', textAlign: 'right', fontWeight: 700, color: '#212529', fontSize: '12px' }}>
                                            {data?.installmentTotal?.resignedUsersSummary?.totalDueCollection !== undefined && data?.installmentTotal?.resignedUsersSummary?.totalDueCollection !== null
                                                ? helper.amountFormatter(data.installmentTotal.resignedUsersSummary.totalDueCollection) + ' SAR'
                                                : '00,00 SAR'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* User Status Section - Simple & Elegant */}
                   
                    <div className="invoiceFooter" style={{ marginTop: '6px', fontSize: '11px' }}>
                        <ul className="contact" style={{ margin: '3px 0', padding: '0', listStyle: 'none', fontSize: '11px' }}>
                            {data?.fees ?
                                <><li style={{ margin: '1px 0', fontSize: '11px' }}>{(Number(data?.fees) > 0 ? "Net Revenue= " : Number(data?.fees) < 0 ? "Discount= " : "") + helper.amountFormatter(data?.fees)}SAR (included in Advance Salaries Paid) </li>
                                    {
                                        data?.taxRate || data?.taxFees ?
                                            <>
                                                <li style={{ margin: '1px 0', fontSize: '11px' }}>Tax Rate on Service Fees: {data?.taxRate}% </li>
                                                <li style={{ margin: '1px 0', fontSize: '11px' }}>Tax on Service Fees: {Number(data?.fees) < 0 ? 0 : (data?.taxFees !== undefined && data?.taxFees !== null ? helper.amountFormatter(data.taxFees) : '00,00')}SAR </li>
                                            </> : ""
                                    }
                                </>
                                : ""}
                            {data?.previousCreditRevenue ?
                                <li style={{ margin: '1px 0', fontSize: '11px' }}>Debit/Credit {(Number(data?.previousCreditRevenue) > 0 ? "Revenue " : Number(data?.previousCreditRevenue) < 0 ? "Discount " : "")}for {data?.date ? moment(data?.date).month(new Date(data?.date).getMonth() - 1).format("MMM YYYY") : ''} = {helper.amountFormatter(Number(data?.previousCreditRevenue).toFixed(2))}SAR</li>
                                : ""}
                        </ul>
                        <p className="contact" style={{ margin: '3px 0', fontSize: '11px' }}>
                            If you have any questions concerning this note, contact <span>partner.success@nowpaysaudi.com</span><br />
                            This Claim isn't a confirmation of your payment.
                        </p>
                        <p className="signature" style={{ margin: '3px 0', fontSize: '11px' }}>
                            <span><span className='signatureWord'>signature:</span></span>
                        </p>
                        <img className='stamp' src={Signature} alt="" style={{ maxHeight: '115px' }} />
                    </div>
                </div>
            </>
        )
    }
}

export default InvoiceTemp